export default __webpack_public_path__ + "static/media/tastebuds.1b220318.jpg";